import React from 'react'
import config from '../../config.json'
import DashboardUpdatetextContainer from '../../containers/PageDashboard/index'
import Translation from '../Translation/cont/Translation'


const PageDashboardContent = () => {
    const dashboardContent = config.dashboardcontent
    const { consultation, accounting, support, contact } = dashboardContent
    
    return (
        <div className="dashboard">
            <div className="header">
                <h4 className="title title-large"><Translation id='dashboard_headline' /></h4>
                <DashboardUpdatetextContainer />
                <p className="subtitle title-large-light"><Translation id="dashboard_contactheadline"/></p>
            </div>
            <div className="content">
                <div className="dashboard-section consultation">
                    <p className="title-large-color"><Translation id="dashboard_consultation_accounting_headline" /></p>
                    <p className="text-regular-uppercase"><Translation id="dashboard_consultation_headline" /></p>
                    <p className="text-regular"><Translation id="dashboard_consultation_salutation" /> {consultation.name}</p>
                    <p className="text-regular-color section-end">{consultation.mail}</p>
                    <p className="text-regular-uppercase"><Translation id="dashboard_accounting_headline" /></p>
                    {/* <p className="text-regular"><Translation id="dashboard_accounting_salutation" /> {accounting.name}</p> */}
                    <p className="text-regular-color">{accounting.mail}</p>
                </div>
                <div className="dashboard-section contact">
                    <p className="title-large-color"><Translation id="dashboard_contact_headline"/></p>
                    <p className="text-regular-uppercase"><Translation id="dashboard_contact_by_phone"/></p>
                    <p className="text-regular section-end">{contact.number}</p>
                    <p className="text-regular-uppercase"><Translation id="dashboard_contact_postal"/></p>
                    <p className="text-regular">{contact.company}</p>
                    <p className="text-regular">{contact.address}</p>
                    <p className="text-regular">{contact.place}</p>
                    <p className="text-regular"><Translation id="dashboard_contact_postal_country"/></p>
                </div>
                <div className="dashboard-section support">
                    <p className="title-large-color"><Translation id="dashboard_support_headline" /></p>
                    <p className="text-regular-uppercase"><Translation id="dashboard_errorsupport_headline"/></p>
                    <p className="text-regular-color section-end">{support.errorsupport.mail}</p>
                    <p className="text-regular-uppercase"><Translation id="dashboard_admin_headline"/></p>
                    <p className="text-regular">{support.technology.name}</p>
                    <p className="text-regular-color">{support.technology.mail}</p>
                </div>
            </div> 
        </div>
    )
}


export default PageDashboardContent






